import React from 'react';
import { Form, Formik } from 'formik';
import { Row, Col } from 'antd';
import InputField from 'shared/components/InputField';
import COSelect from 'shared/components/COSelect';
import COButton from 'shared/components/COButton';
import { ButtonSize } from 'enums/ButtonEnums';
import styles from '../activityDataEntry.module.scss';
import addYearValidationSchema from '../addYearValidationSchema';

interface AddYearModalBodyProps {
  initialValues: {
    fromMonth: string;
    fromYear: string;
    toMonth: string;
    toYear: string;
  };
  yearOptions: {
    label: string;
    value: string;
  }[];
  handleYearChangeWrapper: (
    value: string,
    setFieldValue: (
      field: string,
      value: string,
      shouldValidate?: boolean | undefined
    ) => void
  ) => void;
  handleSubmitWrapper: (values: {
    fromMonth: string;
    fromYear: string;
    toMonth: string;
    toYear: string;
  }) => void;
  setIsModalOpen: (value: boolean) => void;
  yearLoading: boolean;
}

const AddYearModalBody: React.FC<AddYearModalBodyProps> = ({
  initialValues,
  yearOptions,
  handleYearChangeWrapper,
  handleSubmitWrapper,
  setIsModalOpen,
  yearLoading,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={addYearValidationSchema}
      onSubmit={handleSubmitWrapper}>
      {({ setFieldValue }) => (
        <Form>
          <div className={styles.yearFormContainer}>
            <Row gutter={12}>
              <Col span={6}>
                <InputField
                  name="fromMonth"
                  placeholderstring="Month"
                  label={<p className={styles.customStyleLabel}>From</p>}
                  disabled
                />
              </Col>
              <Col span={6}>
                <COSelect
                  name="fromYear"
                  placeholderstring="From Year"
                  options={yearOptions}
                  listHeight={200}
                  onChange={value =>
                    handleYearChangeWrapper(value, setFieldValue)
                  }
                />
              </Col>
              <Col span={6}>
                <InputField
                  name="toMonth"
                  placeholderstring="Month"
                  label={<p className={styles.customStyleLabel}>To</p>}
                  disabled
                />
              </Col>
              <Col span={6}>
                <InputField
                  name="toYear"
                  placeholderstring="To Year"
                  disabled
                />
              </Col>
            </Row>
          </div>
          <div className={styles.yearFormButtonContainer}>
            <Row gutter={16}>
              <Col span={12}>
                <COButton
                  primary
                  size={ButtonSize.LARGE}
                  submit
                  loading={yearLoading}>
                  Submit
                </COButton>
              </Col>
              <Col span={12}>
                <COButton
                  secondary
                  onClick={() => setIsModalOpen(false)}
                  size={ButtonSize.LARGE}>
                  Back
                </COButton>
              </Col>
            </Row>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AddYearModalBody;
